import { FormApi, SubmissionErrors } from 'final-form';
import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { PractitionerFormComponent } from '../../../Forms';
import { PractitionerFormValues } from '../../../Forms/Practitioner';

const PractitionerFormCard = (props: {
  initialValues?: PractitionerFormValues;
  onSubmit: (
    values: PractitionerFormValues,
    form: FormApi<PractitionerFormValues, PractitionerFormValues>,
    callback?: (errors?: SubmissionErrors) => void,
  ) =>
    | SubmissionErrors
    | Promise<SubmissionErrors | undefined>
    | undefined
    | void;
}) => (
  <Card>
    <CardBody>
      <CardTitle>
        <h1>Clinican</h1>
      </CardTitle>
      <hr />
      <PractitionerFormComponent {...props} />
    </CardBody>
  </Card>
);

export default PractitionerFormCard;
